<div
  class="card mb-4 {{ fillFullHeightOfParent ? 'h-100' : '' }}"
  [id]="id"
  [attr.data-sidenav-label]="sidenavLabel"
>
  <div
    class="{{ folded ? 'card-body' : 'card-header' }} 
    {{ !addMarginBottomHeader && !folded ? 'pb-0' : hasIntro && !folded ? 'pb-1' : '' }} {{
      centerTitle ? 'text-center' : 'd-flex justify-content-between'
    }}"
  >
    <div class="d-flex">
      <a (click)="folded = !folded" *ngIf="foldable" class="pe-2">
        <i
          class="fa-solid {{
            folded ? 'fa-circle-chevron-right' : 'fa-circle-chevron-down'
          }} text-secondary"
          title="'{{ title }}' toeklappen"
          style="padding-top: 6px"
        ></i>
      </a>
      <ng-content select="[card-title]"> </ng-content>
      <h5 *ngIf="titleSize == 5">{{ title }}</h5>
      <h4 *ngIf="titleSize == 4">{{ title }}</h4>
      <h3 *ngIf="titleSize == 3">{{ title }}</h3>
      <h2 *ngIf="titleSize == 2">{{ title }}</h2>
      <h1 *ngIf="titleSize == 1">{{ title }}</h1>
    </div>
    <ng-content select="[card-header]"> </ng-content>
  </div>

  <div
    class="card-body pt-0 {{ !addXPaddingBody ? 'px-0' : '' }} {{ addPaddingFooter ? '' : 'pb-0' }}"
    *ngIf="!foldable || !folded"
  >
    <ng-content></ng-content>
  </div>
  <div
    #footerBlock
    class="{{ showFooter ? 'card-footer' : '' }} {{ addPaddingFooter ? '' : 'pt-0' }}"
  >
    <ng-content *ngIf="showFooter" select="[footer]"></ng-content>
  </div>
</div>
